import api from "../../../api";
import {GetGraphQuery} from "platformed-client/types";
import {param, typedQuery} from "../../typing";

export const graph = typedQuery(["vendorToolkit", "graph", param<GetGraphQuery>()], async getGraphQuery => {
  return await api.vendorToolkit.graph.get(getGraphQuery);
});
